import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const SetAccount = ({ open, close, setLoading, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  const handleSetAccount = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/set-employee-account", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Set employee account successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              username: "",
              password: "",
            });
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Set Account"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="set-account"
          initialValues={{
            username: "",
            password: "",
          }}
          onFinish={handleSetAccount}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="username"
              label="Username"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set username" size="large" />
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "5px" }}
              name="password"
              label="Password"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input.Password placeholder="Set password" size="large" />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default SetAccount;
